<template>
  <el-dialog
    title="更新价格"
    :visible.sync="updetaPriceVisible"
    width="700px"
    :before-close="handleClose"
    :close-on-click-modal="false"
  >
    <el-form label-width="100px">
      <el-form-item label="报价类型">
        {{ detailData.priceType | keyFilter('myStore','priceType') }}
      </el-form-item>
      <el-form-item label="单价">
        <el-input-number
          v-if="detailData.priceType === 'YKJ' && detailData.priceList.length"
          v-model.trim="detailData.priceList[0].unitPrice"
          :controls="false"
          class="w220"
        />
        <span v-if="detailData.priceType === 'YKJ'"> 元/{{ detailData.unitName }}</span>
        <el-button
          v-if="detailData.priceType === 'JTJ'"
          size="small"
          type="primary"
          class="m-b-10"
          @click="toAddPrice"
        >
          新增单价
        </el-button>
        <el-table
          v-if="detailData.priceType === 'JTJ'"
          :data="detailData.priceList"
          border
        >
          <el-table-column label="单价">
            <template v-slot="scope">
              <el-input-number
                v-model.trim="scope.row.unitPrice"
                class="w120"
                :controls="false"
              />
            </template>
          </el-table-column>
          <el-table-column label="购买量(起购量)">
            <template v-slot="scope">
              <el-input
                v-model.trim="scope.row.min"
                class="w120"
                type="number"
              />
              {{ detailData.unitName }}
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="80"
          >
            <template v-slot="scope">
              <el-button
                type="text"
                class="red"
                @click="toDeletePrice(scope.row, scope.$index)"
              >
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
    </el-form>
    <div class="m-t-30 m-b-10 text-c">
      <el-button
        type="primary"
        @click="toSubmit"
      >
        确认
      </el-button>
      <el-button @click="handleClose">
        取消
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import api from '@/api'
import { checkPriceMixin } from '@/views/my-store/components/mixin'
export default {
  name: 'UpdatePrice',
  mixins: [checkPriceMixin],
  components: {

  },
  props: {
    updetaPriceVisible: {
      type: Boolean,
      default: false,
    },
    detailData: {
      type: Object,
      default: () => { return { priceList: [] } }
    },
  },
  data () {
    return {
    }
  },
  created () {
    if (this.detailData.priceType === 'DX') {
      this.detailData.priceList = [{
        min: '',
        max: '',
        unitPrice: ''
      }]
    }
  },
  methods: {
    returnSelectedRowData (data) {
      this.selectedRowData = data
    },
    // 新增价格
    toAddPrice () {
      if (this.detailData.priceList.length === 5) {
        this.$message.warning('最多5条阶梯价')
        return
      }
      this.detailData.priceList.push({
        min: undefined, // el-input-number 初始值为undefined不会默认一个0
        max: '',
        unitPrice: undefined
      })
    },
    // 删除价格
    toDeletePrice (row, index) {
      this.detailData.priceList.splice(index, 1)
    },
    toSubmit () {
      // minxin
      if (!this.checkPrice(this.detailData.priceType, this.detailData.priceList)) {
        return
      }
      const param = {
        ...this.detailData,
        id: this.detailData.id,
        priceList: this.detailData.priceList,
        priceType: this.detailData.priceType,
      }
      api.myStore.updateQuotation(param).then(res => {
        this.$message.success('操作成功')
        this.handleClose()
        this.$emit('refresh')
      })
    },
    handleClose () {
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss" scoped>
.warehouse {
  max-height: 500px;
  overflow-y: auto;
}
</style>
